/* eslint-disable prettier/prettier */
import { useState, useEffect } from 'react';
import { fetchEventDots } from '../services/schedule.service';

/**
 * NOTE: the previous version imported MOCK_ACTIVITIES from utils/mockData,
 * a file that was not included in the zip, and ignored year/month while
 * mocking. The mock branch is removed; if you still need it locally,
 * gate it behind your mockData file again.
 */
export function useEventDots(year: number, month: number) {
	const [eventDots, setEventDots] = useState<Set<string>>(new Set());

	useEffect(() => {
		let cancelled = false;

		fetchEventDots(year, month).then(dates => {
			if (!cancelled) setEventDots(new Set(dates));
		});

		return () => {
			cancelled = true;
		};
	}, [year, month]);

	return { eventDots };
}
